<template>
  <v-dialog
    value="true"
    persistent
    width="100%"
    max-width="500">
    <v-card
      :flat="$vuetify.breakpoint.xsOnly"
      class="mx-auto">
      <v-alert
        :value="alertMessage != null"
        dismissible
        color="error">
        {{ alertMessage }}
      </v-alert>

      <v-card-title>
        <span class="mx-auto dialog-title"> {{ expired ? 'Session Expired!' : 'Welcome Back!' }}</span>
      </v-card-title>

      <v-card-text class="pt-2 pb-0">
        <v-layout
          column
          wrap>
          <v-form ref="form">
            <v-flex>
              <v-text-field
                v-model="username"
                label="Username"
                :rules="[rules.required]"
                required
                @keypress.enter="Login" />
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="password"
                type="password"
                label="Password"
                :rules="[rules.required]"
                required
                @keypress.enter="Login" />
            </v-flex>
          </v-form>
        </v-layout>
      </v-card-text>

      <v-card-actions class="py-3">
        <v-layout column>
          <v-btn
            block
            large
            :loading="isLoading"
            class="my-3"
            color="primary"
            @click="Login">
            Login
          </v-btn>

          <template v-if="!expired">
            <span class="mx-auto">No account?</span>

            <v-btn
              text
              color="primary"
              class="my-3"
              to="/setup">
              Setup
            </v-btn>
          </template>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'

import { rules } from '@/mixins/rules'
import errorHandler from '@/mixins/error-handler'

export default {
  mixins: [rules, errorHandler],
  props: {
    expired: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    alertMessage: null,

    username: '',
    password: '',
    isLoading: false
  }),
  methods: {
    Login () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.isLoading = true
      this.alertMessage = null

      const body = `username=${this.username}&password=${this.password}`

      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }

      api.post('/users/login/admin', body, config)
        .then(response => {
          localStorage.setItem('actk', response.data.access_token)

          if (this.expired) {
            this.$store.commit('toggleLoginDialog', false)
            return
          }

          const redirectTo = this.$route.query.redirect

          this.$router.push(redirectTo != null ? redirectTo : '/').catch(() => { })
        })
        .catch(error => {
          this.alertMessage = this.processRequestError(error, true).message
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
